import fetch from "cross-fetch";
import {ApiPrefix, statusCheck, json, getCookie} from '../util/icwUtility'

export const CAREER_FETCH_BEGIN = 'CAREER_FETCH_BEGIN'
function actCareerFetchBegin(token) { return {type: CAREER_FETCH_BEGIN, token } }

export const CAREER_FETCH_SUCCESS = 'CAREER_FETCH_SUCCESS'
export function actCareerFetchSuccess(token, data) { return {type: CAREER_FETCH_SUCCESS, token, data } }

export const CAREER_FETCH_FAIL = 'CAREER_FETCH_FAIL'
function actCareerFetchFail(reason) {return { type: CAREER_FETCH_FAIL, reason } }

export function actCareerInit(token) {

    return dispatch => {
        dispatch(actCareerFetchBegin(token))
        return fetch(`${ApiPrefix}/career/application/${token}`, {
            headers: {"Authorization": getCookie('token')}
        })
            .then(statusCheck)
            .then(json)
            .then(data => dispatch(actCareerFetchSuccess(token, data)))
            .catch(err => {
                dispatch(actCareerFetchFail(typeof(err) === "object" ? err.message : err))
            })
    }
}

export const CAREER_NEXT_STEP = 'CAREER_NEXT_STEP'
export function actCareerNextStep() {return {type: CAREER_NEXT_STEP}}


//
//  ******* Fetch Related *******
//
export const CAREER_SUBMIT_BEGIN = 'CAREER_SUBMIT_BEGIN'
function actCareerSubmitBegin() { return {type: CAREER_SUBMIT_BEGIN} }

export const CAREER_SUBMIT_SUCCESS = 'CAREER_SUBMIT_SUCCESS'
export function actCareerSubmitSuccess(token) { return {type: CAREER_SUBMIT_SUCCESS, token} }

export const CAREER_UPLOAD_SUCCESS = 'CAREER_UPLOAD_SUCCESS'
export function actCareerUploadSuccess(token) { return {type: CAREER_UPLOAD_SUCCESS, token} }

export const CAREER_SUBMIT_FAIL = 'TEST_CAREER_SUBMIT_FAIL'
export function actCareerSubmitFail(reason) { return {type: CAREER_SUBMIT_FAIL, reason} }

export function actCareerSubmit() {
    return (dispatch, getState) => {
        dispatch(actCareerSubmitBegin())

        return fetch(`${ApiPrefix}/career`, {
            method: 'post',
            headers: {'Authorization': getCookie('token'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'},
            body: JSON.stringify(getState().career.data)
        })
            .then(statusCheck)
            .then(json)
            .then(submissionId => {dispatch(actCareerSubmitSuccess(submissionId))})
            .catch(err => {
                dispatch(actCareerSubmitFail(typeof(err) === "object" ? err.message : err))
            })

    }
}



//
//  ******* Update Related *******
//
export const CAREER_PUT_BEGIN = 'CAREER_PUT_BEGIN'
function actCareerPutBegin(token) { return {type: CAREER_PUT_BEGIN, token} }

export const CAREER_PUT_SUCCESS = 'CAREER_PUT_SUCCESS'
export function actCareerPutSuccess(jobId) { return {type: CAREER_PUT_SUCCESS, jobId} }

export const CAREER_PUT_FAIL = 'CAREER_PUT_FAIL'
export function actCareerPutFail(reason) { return {type: CAREER_PUT_FAIL, reason} }

export function actCareerPut() {
    return (dispatch, getState) => {
        dispatch(actCareerPutBegin());
        const { token } = getState().career.data;
        return fetch(`${ApiPrefix}/career/application/${token}`, {
            method: 'PATCH',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'},
            body: JSON.stringify(getState().career.data)
        })
            .then(statusCheck)
            //  .then(json)
            .then(() => dispatch(actCareerPutSuccess(token)))
            .catch(err => {

                dispatch(actCareerPutFail(typeof(err) === "object" ? err.message : err))
            })
    }
}


export const CAREER_INVITE_SUBMIT_BEGIN = 'CAREER_INVITE_SUBMIT_BEGIN'
export function actCareerInviteSubmitBegin() { return {type: CAREER_INVITE_SUBMIT_BEGIN} }

export const CAREER_INVITE_SUBMIT_SUCCESS = 'CAREER_INVITE_SUBMIT_SUCCESS'
export function actCareerInviteSubmitSuccess(token) { return {type: CAREER_INVITE_SUBMIT_SUCCESS, token} }

export const CAREER_INVITE_SUBMIT_FAIL = 'CAREER_INVITE_SUBMIT_FAIL'
export function actCareerInviteSubmitFail(reason) { return {type: CAREER_INVITE_SUBMIT_FAIL, reason} }

export function actCareerInviteSubmit() {
    return (dispatch, getState) => {
        dispatch(actCareerInviteSubmitBegin());

        return fetch(`${ApiPrefix}/career/application`, {
            method: 'post',
            headers: {'Authorization': getCookie('token'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'},
            body: JSON.stringify(getState().careerInvite.data)
        })
            .then(statusCheck)
            .then(json)
            .then(submissionId => dispatch(actCareerInviteSubmitSuccess(submissionId)))
            .catch(err => {
                dispatch(actCareerInviteSubmitFail(typeof(err) === "object" ? err.message : err))
            })

    }
}

